import {Component} from 'react';

import reference from './../../data/reference.json';

const SECTIONS_COUNT = 7;
const HUE_BASE = Math.floor(Math.random() * 255);
const HUE_VARIANCE = Math.floor(256 / SECTIONS_COUNT);

function to_byte(num) {
    return (num + 256) % 256;
}

const EFFECTS_HUE = to_byte(HUE_BASE + 1 * HUE_VARIANCE);
const MORPHOLOGY_HUE = to_byte(HUE_BASE + 2 * HUE_VARIANCE);
const MOTION_STUDY_HUE = to_byte(HUE_BASE + 3 * HUE_VARIANCE);
const TECHNIQUES_HUE = to_byte(HUE_BASE + 4 * HUE_VARIANCE);
const TENDENCIES_HUE = to_byte(HUE_BASE + 5 * HUE_VARIANCE);
const THEORY_HUE = to_byte(HUE_BASE + 6 * HUE_VARIANCE);
const ART_AND_CULTURE_HUE = to_byte(HUE_BASE + 7 * HUE_VARIANCE);

const REFERENCE_PALETTE = {
    "effects": EFFECTS_HUE,
    "morphology": MORPHOLOGY_HUE,
    "motion study": MOTION_STUDY_HUE,
    "techniques": TECHNIQUES_HUE,
    "tendencies": TENDENCIES_HUE,
    "theory": THEORY_HUE,
    "art and culture": ART_AND_CULTURE_HUE
};

export class ReferenceData extends Component {

    static compile = () => {
        let result = {}
        Object.keys(REFERENCE_PALETTE).forEach(key => {
            const key_references = ReferenceData.map_references(key, reference.items[key].items, REFERENCE_PALETTE[key]);
            result = Object.assign({}, result, key_references)
        })
        return result;
    }

    static map_references = (key, items, hue) => {
        let result = {}
        Object.keys(items).forEach(k => {
            if (items[k].value) {
                result[k] = {text: items[k].value, hue: hue, subject: key, detail: items[k]};
            }
        })
        return result;
    }

}

export default ReferenceData;
